module.exports = __webpack_public_path__ + "static/media/beef2.7359dd82.jpg";